
export class QueryLevel {
  /**
   * Pantalla de Consolidado de productos
   */
  public static LVL_ZERO = 0;
  /**
   *  Pantalla de detalle por producto (primer detalle)
   */
  public static LVL_ONE = 1;
  /**
   *  Pantalla de detalle desglosado (detalle final)
   */
  public static LVL_TWO = 2;
}
